export const UPDATE_CONTENT = 'BEAMLY/CCX/UPDATE_CONTENT';

export const updateContent = ({ key, data, shouldMerge = true }) => ({
  type: UPDATE_CONTENT,
  key,
  data,
  shouldMerge,
});
